export const parseAdditionalScores = (gameScore) => {
    if (!gameScore) {
        return {};
    }
    return Object.assign({ homeScore: gameScore.homeScore, awayScore: gameScore.awayScore }, gameScore.additionalScores);
};
//# sourceMappingURL=parseAdditionalScores.js.map